import { gql } from '@apollo/client';

export const USER_ACCOUNT_BALANCE = gql`
  fragment userAccountBalance on AccountBalanceDTO {
    available {
      amount
      currency
    }
    total {
      amount
      currency
    }
    pending {
      amount
      currency
    }
  }
`;

export const MINIMAL_USER_INFO = gql`
  fragment minimalUserInfo on User {
    id
    name
    email
    scientist_profile {
      id
      slug
    }
  }
`;

export const USER_AVATAR = gql`
  fragment userAvatar on Image {
    name
    thumb
    path
    placeholder
  }
`;

const UserFragment = {
  userAccountBalance: USER_ACCOUNT_BALANCE,
  minimalUserInfo: MINIMAL_USER_INFO,
  userAvatar: USER_AVATAR,
};

export default UserFragment;